import React from 'react';
import './LoginBeforeConfirm.scss';
import {showToast} from "../../asstes/js/IntegratedProcessing";
import {inputFocusScroll} from "../../asstes/js/Utils";

class LoginBeforeConfirm extends React.Component {
	state = {
		selectMouseIdx: 2,
		imgBgLoad: false, // 背景图片加载
		imgTop: false,
		phoneNumber: '', // 手机号码
	}


	handleInputChange = (event) => { // 输入事件
		const target = event.target;
		const value = target.value;
		const name = target.name;
		this.setState({
			[name]: value
		})
	}

	loginUser = (e) => {
		e.preventDefault()
		let {phoneNumber} = this.state
		if (phoneNumber !== 'Box8888') {
			showToast('请输入正确的密码！')
		} else {
			this.close()
		}
	}

	close = () => {
		this.props.close && this.props.close.onClose()
	}

	imgLoad = (e) => {
		let name = e.target.name
		this.setState({
			[name]: true
		})
	}

	onBlurHandler = () => { // 失去焦点事件
		setTimeout(() => {
			inputFocusScroll()
		}, 200)
	}

	render() {
		const loginBg = require('../../asstes/img/alert/login.png')
		const loginBtn = require('../../asstes/img/alert/login-btn.png')
		const {phoneNumber, selectMouseIdx} = this.state
		const loginTopArr = [
			require('../../asstes/img/Index/gift-list/login-top1.png'),
			require('../../asstes/img/Index/gift-list/login-top2.png'),
			require('../../asstes/img/Index/gift-list/login-top3.png'),
			require('../../asstes/img/Index/gift-list/login-top4.png'),
			require('../../asstes/img/Index/gift-list/login-top5.png'),
			require('../../asstes/img/Index/gift-list/login-top6.png'),
		]

		return <div className="login-container">
			<p className="prompt"></p>
			<div className="login-relative">
				<img className="login-top-img" name={'imgBgLoad'} onLoad={this.imgLoad} src={loginBg} alt=""/>
				<div className="login-container-content">
					<img src={loginTopArr[selectMouseIdx]} name={'imgTop'} onLoad={this.imgLoad} alt=""/>
					<>
						<div className="login-top-text">
							{/*本活动受邀用户支付<span style={{color: '#fff'}}>1分钱</span>还有惊喜大奖，赶紧输入中国银行手机银行预留手机号码登录参与活动吧！*/}
							密码确认弹窗
						</div>
						<div>
							{/* 手机号码 */}
							<div className="login-input-container">
								<div className="left-part">
									密码
								</div>
								<div className="right-input">
									<input type="password" maxLength="11" placeholder={'密码'}
									       name={'phoneNumber'} ref={'phoneNumber'} value={phoneNumber}
									       onBlur={() => this.onBlurHandler('phoneNumber')}
									       onChange={this.handleInputChange}
									/>
								</div>
							</div>
						</div>
						<a href="/" onClick={(e) => this.loginUser(e)}>
							<img className="login-btn" src={loginBtn} alt=""/>
						</a>
					</>
				</div>
			</div>
		</div>
	}
}

export default LoginBeforeConfirm;
